import React, { Component } from "react";
import { connect } from "react-redux";
import { post } from "../../../../../utils/request";
import "./style.css";
import "../../../../../index.css";
class SubjectView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subjectStr: "",
    };
  }
  componentDidMount() {
    this.requestSubjects();
  }
  render() {
    const { handleVisibleFilter, visible } = this.props;
    const { subjectStr } = this.state;
    return (
      <div
        className={
          visible === true ? "subjectview_box" : "subjectview_box display_none"
        }
      >
        <div className="subjectview_box_left fl">当前选科：{subjectStr}</div>
        <div onClick={handleVisibleFilter} className="subjectview_box_right fl">
          <div className="subjectview_box_right_img fl">
            <img
              alt=""
              src={require("../../../../../images/search/search_1.png")}
            ></img>
          </div>
          <div className="subjectview_box_right_txt fl">筛选</div>
        </div>
        <div className="clear"></div>
      </div>
    );
  }
  /**
   * 请求选科条件详细信息
   */
  requestSubjects() {
    let sessionSubject = JSON.parse(sessionStorage.getItem("suject"));
    let params;
    // 先看看sessionStorage有没有suject的数据，如果没有去redux里面看看
    if(sessionSubject===null){
      params = { ids: this.props.subject };
    }else{
      params = { ids: sessionSubject};
    }
    post("/public/v1/common/subject", params).then((res) => {
      let subjectStr = "";
      res.data.map((item) => {
        return subjectStr = subjectStr + item.name + "、";
      });
      this.setState({
        subjectStr: subjectStr.substr(0, subjectStr.length - 1),
      });
    });
  }
}
const mapStateToProps = (state) => {
  return {
    subject: state.subjectquery.subjectData.subject,
  };
};
export default connect(mapStateToProps)(SubjectView);



// WEBPACK FOOTER //
// ./src/containers/SubjectQuerySchool/SchoolList/components/SubjectView/index.js